import { Article } from 'Types/ArticleTypes';
import { Retina125 } from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import ArticleGridGlobal from './ArticleGridGlobal';
import ArticleTileGlobal from './ArticleTileGlobal';

type Props = {
  chunk: Article[];
  isReversed: boolean;
  listview: boolean;
  isLoading: boolean;
};

const ArticleGridChunk = function ArticleGridChunk(props: Props) {
  const {
    chunk,
    isReversed,
    listview,
    isLoading,
  } = props;
  const isRes = Retina125();
  const isChunkLengthLow = chunk.length <= 4;

  return (
    <ArticleGridGlobal
      isReversed={isReversed}
      listView={listview}
    >
      <div className={classNames('articleMainTileWrapper', { heightUnset: isLoading })}>
        {!(isReversed && isChunkLengthLow) && (
          <ArticleTileGlobal
            key={isReversed
              ? chunk[chunk.length - 1]?.articleId
              : chunk[0]?.articleId}
            article={isReversed ? chunk[chunk.length - 1] : chunk[0]}
            gridTile
            heroArticle
            activityTile
            tileListView
            listView={listview}
            articleWidth="530"
            articleHeight="530"
          />
        )}
      </div>
      <div className="articleGridTilesWrapper">
        {chunk.length > 0
          && (isReversed
            ? isChunkLengthLow
              ? chunk
              : chunk.slice(0, -1)
            : chunk.slice(1)
          ).map(
            (item) => (
              <ArticleTileGlobal
                key={item?.articleId}
                article={item}
                gridTile
                heroArticle
                activityTile
                tileListView
                listView={listview}
                articleWidth={isRes ? '314' : '249'}
                articleHeight={isRes ? '314' : '249'}
              />
            ),
          )}
      </div>
    </ArticleGridGlobal>
  );
};

export default ArticleGridChunk;
